var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEatingRoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54791 11.1042L9.13515 8.00833H9.14664C9.26785 8.00833 9.36611 7.91007 9.36611 7.78886V3.32622C9.36611 3.24911 9.3258 3.17794 9.25991 3.13824C9.19401 3.0985 9.11222 3.09615 9.04425 3.13205C8.18843 3.58362 7.65269 4.47151 7.65269 5.43943V7.32109C7.65269 7.70059 7.96043 8.00831 8.33997 8.00831H8.392L7.97925 11.1041C7.94924 11.3301 8.01808 11.5584 8.16812 11.7299C8.31847 11.9014 8.53558 11.9999 8.76358 11.9999C8.99156 11.9999 9.20869 11.9014 9.35904 11.7299C9.50908 11.5584 9.57792 11.3301 9.54791 11.1042Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10878 3C5.94227 3 5.80752 3.13475 5.80752 3.30124V4.98402H5.50626V3.30124C5.50626 3.13475 5.37152 3 5.20501 3C5.0385 3 4.90377 3.13475 4.90377 3.30124V4.98402H4.60251V3.30124C4.60249 3.13475 4.46775 3 4.30126 3C4.13473 3 4 3.13475 4 3.30124V4.98402V5.2594V6.02019C4 6.46707 4.36214 6.82921 4.80902 6.82921H4.87579L4.40099 11.1018C4.37569 11.3304 4.44893 11.559 4.6022 11.7305C4.75578 11.902 4.97496 12 5.20503 12C5.43509 12 5.65425 11.902 5.80785 11.7305C5.96114 11.559 6.03438 11.3304 6.00906 11.1018L5.53424 6.82923H5.60103C6.04789 6.82923 6.41005 6.46709 6.41005 6.02021V5.25942V4.98404V3.30124C6.41003 3.13475 6.27528 3 6.10878 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEatingRoom);
export default __webpack_public_path__ + "static/media/icon-eating-room.c395c538607586d0c5e102d24a0766a7.svg";
export { ForwardRef as ReactComponent };